import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';;
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import InfoButton from './InfoButton';
import { colormaps } from '../js/constants';

export default function ColorsSelect(props) {
	const { userParams, setUserParams } = props;
	const [ colorCount, setColorCount ] = useState(0);
	const [ cmpName, setCmpName ] = useState(userParams.cmap);
	const [ colorError, setColorError ] = useState(false);
	const [ validColorMaps, setValidColorMaps ] = useState([]);
	const colormap_keys = Object.keys(colormaps);
	const numLevels = userParams.clevels.filter((e) => { return e === 0 || e }).length;  //remove falsy, but not zero

	const handleChange = (event) => {
		const val = event.target.value;
		setCmpName(val);
		if (colormaps[val].hasOwnProperty(colorCount)) {
			const newColors = colormaps[val][colorCount];
			setUserParams({...userParams, cmap: val, colors: newColors});
			setColorError(false);
		}
	};
	
	const selectColor = () => {
		return (
			validColorMaps.map(val => {
				return (
					<MenuItem 
						dense={true}
						sx={{ pt:0, pb:0 }}
						key={val} 
						value={val}
						selected={val === cmpName}
					>
						<TableContainer>
							<Table padding="none">
								<TableBody>
									<TableRow>
										<TableCell sx={{ pr: 1 }}>{val}</TableCell>
											{colormaps[val][colorCount].map((cs, i) => (
												<TableCell key={i} style={{width:"1em", backgroundColor:"" + cs + ""}}>&nbsp;</TableCell>
											))}
									</TableRow>	
								</TableBody>
							</Table>
						</TableContainer>
					</MenuItem>
				)
			})
		);
	};

	useEffect(() => {
		if (numLevels >= 2) {
			setColorCount(numLevels + 1);
			const colorMapsToList = colormap_keys.filter((cname) => { return Object.keys(colormaps[cname]).includes((numLevels + 1).toString()) });
			setValidColorMaps(colorMapsToList);
			if (colorMapsToList.indexOf(cmpName) === -1) {
				setUserParams({...userParams, cmap: "", colors: []});
				setCmpName("");
				setColorError(true);
			} else if (colormaps[cmpName].hasOwnProperty(numLevels + 1)) {
				const newColors = colormaps[cmpName][numLevels + 1];
				setUserParams({...userParams, cmap: cmpName, colors: newColors});
				setColorError(false);
			} else {
				setCmpName("");
				setColorError(true);
			}
		}
	}, [numLevels, userParams.cmap]);

	return ( 
		<div>
			{numLevels >= 2 && numLevels <= 11 && validColorMaps.length > 0 &&
				<Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 2 }}>
					<TextField
						select
						name="colormap"
						label="Color map"
						value={cmpName}
						onChange={handleChange}
						InputProps={{endAdornment: <InfoButton adornment="end" infoFor='colormap' />}}
						sx={{ minWidth: "10em", "& .MuiSelect-icon": { right: '28px' } }}
					>
						{selectColor()}
					</TextField>
					{colorError &&
						<Typography sx={{ fontStyle: "italic" }} variant="caption">
							Invalid color map {cmpName}; select another from the list or reduce number of contour levels.
						</Typography>
					}
				</Stack>
			}
			{numLevels < 2 || numLevels > 11 &&
				<Typography sx={{ mt: 1, fontStyle: "italic" }} variant="caption" gutterBottom>
					Color selection is only available for between 2 and 11 contour levels.
				</Typography>
			}

		</div>
	);
}

